export const rewriteSlug = (slug: string) => {
  const rewrittenSlug: string = slug
    .replace(`${process.env.GATSBY_DEFAULT_LANGUAGE}/`, '')
    .replace(`${process.env.GATSBY_DOMAIN_FOLDER}/`, '');
  return rewrittenSlug || '/';
};
